export default __webpack_public_path__ + "static/media/subtract-circle 1.80b540d1.svg";